import React from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { styled } from '@uhg-abyss/web/tools/styled';

const CardContent = styled('div', {
  padding: '8px 16px 16px',
  fontSize: '15px',
  fontWeight: '400',
  lineHeight: '1.7',
  textAlign: 'justify',
});

const CardTitle = styled('div', {
  backgroundColor: '#0000',
  color: '#002677',
  fontSize: '16px',
  fontWeight: '700',
  padding: '12px ',
  marginTop: '10px',
});

export const CreateCommunicationPageDesc = () => {
  return (
    <Card id="communicationsCornerCard">
      <CardTitle>Communications Corner</CardTitle>
      <div>
        <CardContent>
          Welcome to the Communications Corner. This is reserved to be used by
          API Marketplace Onboarding team only. You can draft out the
          communications or send them out to designated clients. All
          communications and drafts will be saved here for future use up to 6
          months. Drafts are limited to 5 only.
        </CardContent>
      </div>
    </Card>
  );
};
